export default __webpack_public_path__ + "static/hotblack-coffee-space-2ffc3e3d1334e1a91588d2ab34c0b669.jpg";